import { DataSource, Layout, Table} from "@mcleod/components";

export abstract class AutogenLayoutLocationLucene extends Layout {
	sourceLocationLucene: DataSource;
	tableLocation: Table;
}
